import { useDispatch, useSelector } from "react-redux";
import {
  addSubject,
  deleteSubject,
  getSubject,
  updateSubject,
  setRidirect,
  setOffset,
  setPage,
  setPerPage,
} from "../store/subject";

export default function useSubject() {
  const dispatch = useDispatch();

  const subjectData = useSelector((state) => state.subject.data);
  const loading = useSelector((state) => state.subject.loading);
  const redirect = useSelector((state) => state.subject.redirect);

  const page = useSelector((state) => state.subject?.page);
  const perPage = useSelector((state) => state.subject?.perPage);
  const offset = useSelector((state) => state.subject?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const getSubjectAction = (params) => dispatch(getSubject(params));
  const setRidirectAction = () => dispatch(setRidirect());
  const updateSubjectAction = (params) => dispatch(updateSubject(params));
  const deleteSubjectAction = (params) => dispatch(deleteSubject(params));
  const addSubjectAction = (params) => dispatch(addSubject(params));

  return {
    subjectData,
    loading,
    redirect,
    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,
    getSubjectAction,
    updateSubjectAction,
    deleteSubjectAction,
    addSubjectAction,
    setRidirectAction
  };
}
